/** Is the sportsbook showing its LIVE tab?
 *
 *  MEASURED on parikara 2026-09-09: the Live and Sport tabs share the path
 *  (`/digsport/home`), carry no hash and no active class anywhere in the DOM;
 *  the only thing that flips is the app store's `selectTopMenu`
 *  ("LIVE" | "SPORT" | …). A match page keeps the value of the tab it was
 *  opened from. Read-only, in memory, never throws. */
export function isLiveTab(w: unknown = typeof window !== "undefined" ? window : null): boolean {
  try {
    const win = w as { sportdigi?: { mobile?: { store?: { getState?: () => unknown } } } } | null;
    const state = win?.sportdigi?.mobile?.store?.getState?.() as { selectTopMenu?: unknown } | undefined;
    return String(state?.selectTopMenu ?? "").toUpperCase() === "LIVE";
  } catch {
    return false;
  }
}
